export { default } from './useProduct';
export * from './useProduct';
